;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlTabs', zlTabsDirective)
  zlTabsDirective.$inject = ['$rootScope', '$timeout']

  function zlTabsDirective ($rootScope, $timeout) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {},
      controller: ['$scope', function ($scope) {
        var panes = $scope.panes = []

        $scope.select = function (pane) {
          angular.forEach(panes, function (pane) {
            pane.selected = false
            pane.actived = false
          })
          pane.selected = true
          pane.actived = true

          if (_.get(pane, 'icon') === 'mdi-traffic-light' && _.get(pane, 'label') === 'STATUTS') {
            $timeout(function () {
              $rootScope.$broadcast('select-status-pane')
            }, 300)
          }
        }

        $scope.over = function (pane) {
          angular.forEach(panes, function (pane) {
            pane.actived = false
          })
          pane.actived = true
        }

        $scope.leave = function (pane) {
          $scope.hover = false
          angular.forEach(panes, function (pane) {
            pane.actived = false
            if (pane.selected === true) {
              pane.actived = true
            }
          })
        }

        this.addPane = function (pane) {
          if (panes.length === 0) {
            $scope.select(pane)
          }
          panes.push(pane)
        }
      }],
      template:
      '<div style="position: relative; height: 100%;">' +
      '<div class="tabs-advanced-search" ng-class="{hover: hover}" ng-mouseleave="leave(pane)" ng-mouseover="hover = true">' +
      '<div ng-repeat="pane in panes" ng-class="{active: pane.actived}">' +
      '<div  ng-click="select(pane)" ng-mouseover="over(pane)"><i class="mdi {{pane.icon}}"></i></div>' +
      '</div>' +
      '</div>' +
      '<div ng-repeat="pane in panes" ng-hide="pane.selected" class="preview-pane" ng-class="{active: pane.actived}"><i class="mdi {{pane.icon}}"></i><span>{{pane.label}}</span><small>Cliquer sur l\'icône pour accéder à l\'onglet</small></div>' +
      '<div class="tab-content tabs-advanced-search--content" ng-class="{active: pane.actived}" ng-transclude></div>' +
      '</div>',
      replace: true
    }
  }

  angular
    .module('kilo.common.directives')
    .directive('pane', zlTabsPanesDirective)

  zlTabsPanesDirective.$inject = []

  function zlTabsPanesDirective () {
    return {
      require: '^zlTabs',
      restrict: 'E',
      transclude: true,
      scope: {
        icon: '@',
        label: '@'
      },
      link: function (scope, element, attrs, tabsCtrl) {
        tabsCtrl.addPane(scope)
        scope.icon = scope.icon || element[0].children[0].getAttribute('icon')
        scope.label = scope.label || element[0].children[0].getAttribute('label')
      },
      template:
      '<div class="tab-pane" ng-class="{active: selected}" ng-transclude>' +
      '</div>',
      replace: true
    }
  }
})(window.angular, window._)
